import * as React from 'react';
import { get, set } from 'lodash-es';
import { Grid, Select } from '@easyv/react-components';
import { deepClone } from '@easytwin/runtime';
import { ImmerFormItem, ProInputEulerNumber, ProInputNumber } from '@/UIGenerator';
import { ParticleSystemBaseInputType } from '@/type';
import { CurveEditorTrigger } from './CurveEditorTrigger';

const Row = Grid.Row;
const Col = Grid.Col;

interface ParticleSystemBaseInputTypeProps {
  label: string;
  name: string;
  value: ParticleSystemBaseInputType;
  suffix?: React.ReactNode;
  useEuler?: boolean;
  onConfirm: (value: ParticleSystemBaseInputType) => void;
  onChange: (value: ParticleSystemBaseInputType) => void;
}

export function ParticleSystemBaseInput(props: ParticleSystemBaseInputTypeProps) {
  const { label, name, useEuler, value, suffix, onChange, onConfirm } = props;

  const handleChange = (n: string, v: unknown) => {
    const newValue = deepClone(value);
    set(newValue, n, v);

    onChange(newValue);
  };

  const handleConfirm = (n: string, v: unknown) => {
    const newValue = deepClone(value);
    set(newValue, n, v);
    onConfirm(newValue);
  };

  const BaseInput = useEuler ? ProInputEulerNumber : ProInputNumber;

  const configureItem = (() => {
    switch (value?.type) {
      case 'ConstantValue':
        return (
          <Col span={16}>
            <BaseInput
              precisionOnShow={2}
              suffix={suffix}
              value={get(value, 'ConstantValue.value')}
              name={'ConstantValue.value'}
              onChange={handleChange}
              onBlur={handleConfirm}
            />
          </Col>
        );
      case 'IntervalValue':
        return (
          <Col span={16}>
            <div className='flex'>
              <BaseInput
                precisionOnShow={2}
                suffix={suffix}
                value={get(value, 'IntervalValue.a') || 0}
                name={'IntervalValue.a'}
                onChange={handleChange}
                onBlur={handleConfirm}
              />
              <div className='h-7 flex items-center justify-center mx-2 text-content4'>-</div>
              <BaseInput
                precisionOnShow={2}
                suffix={suffix}
                value={get(value, 'IntervalValue.b') || 0}
                name={'IntervalValue.b'}
                onChange={handleChange}
                onBlur={handleConfirm}
              />
            </div>
          </Col>
        );

      case 'AnimationCurve':
        return (
          <Col span={16}>
            <CurveEditorTrigger
              value={get(value, 'AnimationCurve.value')}
              onChange={(value) => {
                handleConfirm('AnimationCurve.value', value);
              }}
            />
          </Col>
        );
      default: {
        <Col span={16}></Col>;
      }
    }
  })();

  return (
    <ImmerFormItem label={label}>
      <Row gutter={8}>
        {configureItem}
        <Col span={8}>
          <Select
            size='small'
            value={get(value, 'type')}
            onChange={(v) => {
              handleConfirm('type', v);
            }}
            options={[
              { label: '常量', value: 'ConstantValue' },
              { label: '随机', value: 'IntervalValue' },
              { label: '曲线', value: 'AnimationCurve' },
            ]}
          />
        </Col>
      </Row>
    </ImmerFormItem>
  );
}
